// extracted by mini-css-extract-plugin
export default {"root":"info-button-module--root--d8587","text":"info-button-module--text--c92c2"};